// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { withStyles } from '@material-ui/core/styles';

import * as profileActions from
  '../../pages/account/components/AccountTab/components/MyProfile/store/actions';
import { getPaypal, getConfirmPaypalEmail } from
  '../../pages/account/components/AccountTab/components/MyProfile/store/selectors';
import Input from '../Input/Input';
import styles from './styles';

class PayPalForm extends Component {
  state = {};

  componentDidMount() {
    const id = localStorage.getItem('loggedID');
    const token = localStorage.getItem('token');
    this.props.requestPaymentPayPal(id, token);
  }

  onChangeEmail = (value, name) => {
    this.props.setConfirmPaypalNull(false);
    this.props.changeFieldPaypal(value, name);
  }

  render() {
    const { classes } = this.props;
    const EmailProps = {
      label: 'Email',
      name: 'PaypalEmail',
      value: this.props.paypal.PaypalEmail,
      onChange: this.onChangeEmail,
    };
    const ConfirmEmailProps = {
      label: 'Confirm email',
      name: 'ConfirmPaypalEmail',
      value: this.props.ConfirmPaypalEmail,
      onChange: this.props.changeFieldConfirmPaypal,
    };

    return (
      <MediaQuery minWidth={500}>
        {matches => (matches
          ? (
            <div className={classes.inputContainer}>
              <Input width={400} {...EmailProps} />
              <Input width={400} {...ConfirmEmailProps} />
            </div>)
          : (
            <div className={classes.inputContainer}>
              <Input {...EmailProps} />
              <Input {...ConfirmEmailProps} />
            </div>))}
      </MediaQuery>
    );
  }
}

PayPalForm.propTypes = {
  classes: PropTypes.object,
  requestPaymentPayPal: PropTypes.func,
  paypal: PropTypes.object,
  ConfirmPaypalEmail: PropTypes.string,
  changeFieldPaypal: PropTypes.func,
  changeFieldConfirmPaypal: PropTypes.func,
  setConfirmPaypalNull: PropTypes.func,
};
PayPalForm.defaultProps = {
  classes: {},
  requestPaymentPayPal: () => { },
  paypal: {},
  ConfirmPaypalEmail: null,
  changeFieldPaypal: () => { },
  changeFieldConfirmPaypal: () => { },
  setConfirmPaypalNull: () => { },
};

const mapStateToProps = (state) => {
  return {
    paypal: getPaypal(state),
    ConfirmPaypalEmail: getConfirmPaypalEmail(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestPaymentPayPal: (id, token) => dispatch(profileActions.requestProfile(id, token)),
    changeFieldPaypal: (value, name) => dispatch(profileActions.changeFieldPaypal(value, name)),
    changeFieldConfirmPaypal: (value, name) => dispatch(profileActions
      .changeFieldConfirmPaypal(value, name)),
    setConfirmPaypalNull: isChangeFirstTime => dispatch(profileActions
      .setConfirmPaypalNull(isChangeFirstTime)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PayPalForm));
